import { useState, useEffect } from 'react';
import AgreementDark from '../../../img/icons/agreements-dark.svg';
import AgreementLight from '../../../img/icons/agreements-light.svg';
import GovernanceDark from '../../../img/icons/governance-dark.svg';
import GovernanceLight from '../../../img/icons/governance-light.svg';
import ComplaintsDark from '../../../img/icons/complaints-dark.svg';
import ComplaintsLight from '../../../img/icons/complaints-light.svg';
import WorkforceDark from '../../../img/icons/workforce-dark.svg';
import WorkforceLight from '../../../img/icons/workforce-light.svg';
import ReportingDark from '../../../img/icons/reporting-dark.svg';
import ReportingLight from '../../../img/icons/reporting-light.svg';
import ArrowDark from '../../../img/icons/arrow-dark.svg';
import ArrowLight from '../../../img/icons/arrow-light.svg';
import ArrowMobile from '../../../img/icons/arrow-mobile.svg';
import styles from './topicTileStyle.module.css';

export default function TopicTile ({ icon, label, href }) {
  const [isMobile, setIsMobile] = useState(false);
  const [isHover, setIsHover] = useState(false);

  const iconOptions = {
    agreement: [<AgreementDark />, <AgreementLight />],
    governance: [<GovernanceDark />, <GovernanceLight />],
    complaints: [<ComplaintsDark />, <ComplaintsLight />],
    workforce: [<WorkforceDark />, <WorkforceLight />],
    reporting: [<ReportingDark />, <ReportingLight />]
  };
  useEffect(() => {
    const checkIsMobile = () => {
      setIsMobile(window.innerWidth <= 576);
    };

    checkIsMobile();
    window.addEventListener('resize', checkIsMobile);

    return () => {
      window.removeEventListener('resize', checkIsMobile);
    };
  }, []);

  return (
    <a href={href} className={styles.contentBox} onMouseEnter={() => { setIsHover(true); }} onMouseLeave={() => { setIsHover(false); }}>
      <div className={styles.labelContainer}>
        <div className={styles.iconContainer}>
          {(isHover && !isMobile) ? iconOptions[icon][1] : iconOptions[icon][0]}
        </div>
        <h5 className={`${styles.label} ${(isHover && !isMobile) && styles.labelHover}`}>{label}</h5>
      </div>
      <div className={styles.arrow}>
        {isMobile ? <ArrowMobile /> : (isHover ? <ArrowLight /> : <ArrowDark />)}
      </div>
    </a>
  );
}
